module.exports = __webpack_public_path__ + "static/media/1350_Cart_GiftShop_editHL.698a75c1.png";